import { Component } from '@angular/core';
import { PoMenuItem, PoToolbarAction } from '@po-ui/ng-components';
import { Authguard } from './core/auth/auth.guard';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: false
})
export class AppComponent {

  readonly menus: Array<PoMenuItem> = [];
  notificationActions: Array<PoToolbarAction> = [];
  mostraMenu: boolean = false;
  menuAd: boolean = false;

  constructor(private authservice: Authguard) {

    this.menus = [
      { label: 'Home', icon: ' an an-house-line', shortLabel: 'Home', link: '/' },
      { label: 'Central de Diagnóstico', icon: ' an an-sliders-horizontal', shortLabel: 'Central de Diagnóstico', link: '/cd' },
      {
        label: 'Manifestos', icon: ' an an-clipboard-text', shortLabel: 'Manifestos', subItems: [
          { label: 'Painel de Conformidade', link: '/manifest' },
          { label: 'Cadastro', link: '/manifest-admin' }
        ]
      },
      {
        label: 'Atusx', icon: ' an an-package', shortLabel: 'Atusx', subItems: [
          { label: 'Novo Pacote', link: '/atusx/new-package-dic' }
        ]
      },
    ];
  }

  ngOnInit() {
    this.authservice.mostraMenuEmit.subscribe(
      mostrar => this.mostraMenu = mostrar
    );
    this.authservice.menuAdmin.subscribe(
      isAdmin => { if (isAdmin) this.menuAlter(); }
    );
  }

  menuAlter() {
    if (this.menuAd) {
      return;
    }

    const atusxMenu = this.menus.find(menu => menu.label === 'Atusx');
    if (atusxMenu) {
      atusxMenu.subItems = [
        ...(atusxMenu.subItems || []),
        { label: 'Administração de Pacotes', link: '/atusx/package-admin' }
      ];
    }

    this.menus.push(
      {
        label: 'Expedição', icon: ' an an-archive', shortLabel: 'Exped.', subItems: [
          { label: 'Acumulado', link: '/approve' },
          { label: 'Artefatos', link: '/artifacts' },
          { label: 'Binário', link: '/binary' },
          {
            label: 'Documentação', icon: ' an an-files', shortLabel: 'Documentação', subItems: [
              { label: 'Cópia', link: '/expedition/doc-approval' },
              { label: 'Geração', link: '/expedition/doc-generation' }
            ]
          }
        ]
      },
      {
        label: 'Configurações', icon: ' an an-gear', shortLabel: 'Config.', subItems: [
          { label: 'Acessos', link: '/access' },
          {
            label: 'Central de notificações', icon: ' an an-gear', shortLabel: 'Notificações.', subItems: [
              { label: 'Categorias', link: '/notifications-categories' },
              { label: 'Configurações das notificações', link: '/notifications-config' },
            ]
          },
        ]
      },
    );

    this.menuAd = true;
  }

}
